export default __webpack_public_path__ + "static/media/product-03.3655749b.jpg";